import { TableCell, TableCellProps, TableSortLabel } from '@mui/material';

import { TableSortState } from '@/hooks/useTableSort';

type SortableTableCellProps = TableCellProps & {
  sortKey: string;
  sort: TableSortState;
};

/** Header cell that toggles client-side sorting via `useTableSort`. */
export const SortableTableCell = ({
  sortKey,
  sort,
  children,
  ...props
}: SortableTableCellProps) => {
  const active = sort.sortKey === sortKey;
  return (
    <TableCell sortDirection={active ? sort.direction : false} {...props}>
      <TableSortLabel
        active={active}
        direction={active ? sort.direction : 'asc'}
        onClick={() => sort.requestSort(sortKey)}
        sx={{ color: 'inherit', '&.Mui-active': { color: 'inherit' } }}
      >
        {children}
      </TableSortLabel>
    </TableCell>
  );
};
